import React from "react";
import { FrameInterface } from "src/store/mine_craft/framesSlice";
import CardImage from "../../../../componets/CardImage";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { setEditId } from "../../../../store/mine_craft/framesSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyFrame } from "../../../../actions/mine_craft/framesActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import IconText from "../../../../componets/IconText";
import { DollarOutlined } from "@ant-design/icons";

interface propsInterface {
  frame: FrameInterface;
}

const Card = ({ frame }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const formattedCreatedAt = formattedDate(frame.created_at);

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyFrame(id));

    if (destroyFrame.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyFrame.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      className={'v-mine_craft-frames__card'}
      image={frame.image_url}
      size='medium'
      options={[
        <ButtonEdit key={`edit-${frame.id}`} onClick={() => onClickEdit(frame.id)} />,
        <ButtonDestroy key={`destroy-${frame.id}`} onClick={() => onClickDestroy(frame.id)} />
      ]}
      stats={[
        <IconText tooltip='popular' icon={DollarOutlined} text={frame.coins} />,
      ]}
    >
      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
